import React from 'react';
import * as properties from '../../elementsPropertiesItems';
import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const Dimension = (props)=>{
    const {path,keyParam,alignTypes,elementData} = props;
    let imgWidth = (isSet(elementData.attributes.width,null)!==null)?elementData.attributes.width:'auto';
    let imgHeight = (isSet(elementData.attributes.height,null)!==null)?elementData.attributes.height:'100';
    


    const changeHandler = (e,attrtype,dimensionIndex) => {        
        const {value} = e.target;        
        props.changeHandler('.attributes',attrtype,value);
    }  

    return(
        <div className="w-100">
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Width</span>
                </div>              
                <input type="text" className="form-control" value={imgWidth} onChange={e=>changeHandler(e,'width',0)} />
                {/*<div className="input-group-append">
                    <span className="input-group-text"> px </span>                    
                </div>*/}
            </div>
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Height</span>
                </div>                
                <input type="text" className="form-control" value={imgHeight} onChange={e=>changeHandler(e,'height',1)} />
                {/*<div className="input-group-append">
                    <span className="input-group-text"> px </span>                    
                </div>*/}
            </div>                             
        </div>
    )
}


export default Dimension;